// src/app/shared/pipes/iso-to-jalali.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { from as jFrom } from 'jalali-moment';

@Pipe({
    name: 'isoToJalali',
})
export class IsoToJalaliPipe implements PipeTransform {
    /**
     * ورودی: تاریخ میلادی ISO (مثلاً '2025-08-16' یا '2025-08-16T12:30:00Z')
     * خروجی: رشتهٔ جلالی با فرمت دلخواه (پیش‌فرض: YYYY/MM/DD)
     */
    transform(
        iso: string | Date | null | undefined,
        fmt = 'jYYYY/jMM/jDD',
        persianDigits = true
    ): string {
        if (!iso) return '';
        const d:any = typeof iso === 'string' ? new Date(iso) : iso;
        const m = jFrom(d, 'en');
        if (!m.isValid()) return '';
        const out = m.locale('fa').format(fmt); // j* => تقویم جلالی + عناوین فارسی
        return persianDigits ? out.replace(/\d/g, (ch) => '۰۱۲۳۴۵۶۷۸۹'[+ch]) : out;
    }
}
